import React, { useEffect, useState } from "react";
import Box from "@components/Box";
import Container from "@components/Container";
import CustomModal from "@components/CustomModal";
import DetailButton from "@components/DetailButton";
import InfoTable from "@components/InfoTable";
import LoadingSpinner from "@components/LoadingSpinner";
import LogisticService from "@LogisticService";
import { Link } from "../styles";
import DetalhesOS from "./DetalhesOS";

export default function OSsPendentesPolo(props) {
  const title = "OSs Pendentes";
  const [oSsPendentesPolo, setOSsPendentesPolo] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [visibleModal, setVisibleModal] = useState(undefined);
  const [visibleDetalhesOs, setVisibleDetalhesOs] = useState(false);
  const [oSSelecionada, setOSSelecionada] = useState(undefined);

  useEffect(() => {
    LogisticService.getPendentesPolo(props.polo).then((response) => {
      const result = [];
      response.data.forEach((item) => {
        result.push({
          data: item.data,
          servico: item.servico,
          volume_oss: item.volume_oss,
          oss: item.oss,
        });
      });
      setOSsPendentesPolo(result);
      setLoaded(true);
    });
  }, [props.polo]);

  const dados = [];
  const colunas = [
    {
      label: "Serviço",
      key: "servico",
      align: "start",
      sort: {
        compare: (a, b) => a.servico.localeCompare(b.servico),
      },
    },
  ];
  const servicos = [];
  const datas = [];
  const downloadLabels = ["Serviço"];
  const downloadData = [];
  const modalData = [];

  oSsPendentesPolo.forEach((item) => {
    if (!servicos.includes(item.servico)) {
      servicos.push(item.servico);
    }
    if (!datas.includes(item.data)) {
      datas.push(item.data);
    }
  });

  servicos.forEach((servico) => {
    const row = { servico: servico };
    oSsPendentesPolo.forEach((item, id) => {
      if (item.servico === servico) {
        row[item.data] = (
          <>
            {item.volume_oss}{" "}
            <DetailButton onClick={() => setVisibleModal(id)} />
          </>
        );
        row[item.data + "_num"] = item.volume_oss;
        modalData.push(
          <CustomModal
            title={`OSs que vencem em ${item.data} ${item.servico}`}
            key={id}
            visible={visibleModal === id}
            zIndex={1000}
            onCancel={() => setVisibleModal(undefined)}
            footer={null}
          >
            <Box maxHeight={"400px"} margin={"0"} padding={"0"} scroll>
              {item.oss.map((os) => (
                <Link
                  onClick={() => {
                    setOSSelecionada(os);
                    setVisibleDetalhesOs(true);
                  }}
                >
                  {os}
                </Link>
              ))}
            </Box>
          </CustomModal>
        );
      }
    });
    dados.push(row);
  });

  dados.forEach((item) => {
    const rowDownload = [item.servico];
    datas.forEach((data) => {
      if (item[data + "_num"]) {
        rowDownload.push(item[data + "_num"]);
      } else {
        rowDownload.push("");
      }
    });
    downloadData.push(rowDownload);
  });

  datas.forEach((data) => {
    colunas.push({ label: data, key: data });
    downloadLabels.push(data);
  });

  const tableData = {
    data: dados,
    columns: colunas,
  };

  useEffect(() => {
    if (downloadData.length > 0) {
      props.downloadAll.push({
        index: props.index,
        title: title,
        labels: downloadLabels,
        data: downloadData,
      });
    }
  }, [loaded]);

  return (
    <Container
      title={title + " - " + props.name}
      info={[`OSs Pendentes ${props.name}`]}
      downloadLabels={loaded ? downloadLabels : []}
      downloadData={loaded ? downloadData : []}
    >
      {loaded ? <InfoTable data={tableData} /> : <LoadingSpinner />}
      <CustomModal
        title={`Detalhes OS ${oSSelecionada}`}
        visible={visibleDetalhesOs}
        zIndex={1010}
        onCancel={() => setVisibleDetalhesOs(false)}
        footer={null}
      >
        <DetalhesOS os={oSSelecionada} />
      </CustomModal>
      {modalData}
    </Container>
  );
}
